import { render, staticRenderFns } from "./blindMain.vue?vue&type=template&id=a4bf78ae&scoped=true&"
import script from "./blindMain.vue?vue&type=script&scoped=true&lang=js&"
export * from "./blindMain.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./blindMain.vue?vue&type=style&index=0&id=a4bf78ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bf78ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4bf78ae')) {
      api.createRecord('a4bf78ae', component.options)
    } else {
      api.reload('a4bf78ae', component.options)
    }
    module.hot.accept("./blindMain.vue?vue&type=template&id=a4bf78ae&scoped=true&", function () {
      api.rerender('a4bf78ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/blindMain.vue"
export default component.exports